export default __webpack_public_path__ + "static/media/kabaranak-1.bdb134fd.png";